var subscribeOptions = {
    selectorId: "subscribe",
    triggerClass: "subscribe__toggle",
    submitClass: "subscribe__submit",
    contentClass: "subscribe__content",
    selector: "",
    form: "",
    button: "",
    formNotification: "",
    successContainer: ".subscribe-success",
    notConfirmedContainer: ".subscribe-notconfirmed",
    existContainer: ".subscribe-warning",
    errorContainer: ".subscribe-error",
    init: function() {
        this.selector = $("#" + this.selectorId);
        this.trigger = $(this.selector).find("." + this.triggerClass);
        this.submit = $(this.selector).find("." + this.submitClass);
        this.content = $(this.selector).find("." + this.contentClass);
        this.form = $(this.selector).find("form");
        this.button = $(this.selector).find("." + this.submitClass);
        this.formNotification = $(this.selector).find(".form-notification");
    }
};

var subscribeHandler = {
    initSubscribe: function(e) {
        $(subscribeOptions.button).prop("disabled", true);

        subscribeHandler.submitForm(e);
    },

    submitForm: function() {
        var formArray = $(subscribeOptions.form).serializeArray();

        var nodeId = formArray[0].value,
            name = formArray[1].value,
            email = formArray[2].value;

        var url = $(subscribeOptions.form).attr("action");
        $.ajax({
            type: "POST",
            url: url,
            data: {
                nodeId: nodeId,
                subscriberName: name,
                subscriberEmail: email
            },
            success: function(e) {
                if (e.data) {
                    subscribeHandler.responseHandler(e.data);
                } else {
                    subscribeHandler.responseHandler(e);
                }
            },
            error: function() {
                subscribeHandler.responseHandler(null);
            }
        });
    },
    responseHandler: function(status) {

        $(subscribeOptions.formNotification).find("div").hide();

        if (status == "valid" || status == 3) {
            $(subscribeOptions.form).slideUp(400);
            $(subscribeOptions.formNotification).find(subscribeOptions.successContainer).fadeIn(300);
        } else if (status == "alreadyExist" || status == 1) {
            $(subscribeOptions.button).prop("disabled", false);
            $(subscribeOptions.formNotification).find(subscribeOptions.existContainer).fadeIn(300);
        } else if (status == "notConfirmed" || status == 6) {
            $(subscribeOptions.button).prop("disabled", false);
            $(subscribeOptions.formNotification).find(subscribeOptions.notConfirmedContainer).fadeIn(300);
        }

        else {
            $(subscribeOptions.button).prop("disabled", false);
            $(subscribeOptions.formNotification).find(subscribeOptions.errorContainer).fadeIn(300);
        }
    }
};

var openCloseHandler = {
    openCloseToggle: function() {
        var isActive = $(subscribeOptions.content).hasClass("active");
        if (!isActive) {
            openCloseHandler.openSubscribe();
        } else {
            openCloseHandler.closeSubscribe();
        }
    },

    openSubscribe: function() {
        $(subscribeOptions.trigger).addClass("active");

        $(subscribeOptions.content)
            .slideDown()
            .addClass("active");
    },

    closeSubscribe: function() {
        $(subscribeOptions.trigger).removeClass("active");

        $(subscribeOptions.content)
            .slideUp()
            .removeClass("active");
    }

};

$(function () {

    subscribeOptions.init();

    $(subscribeOptions.trigger).on("click", function (e) {
        e.preventDefault();
        openCloseHandler.openCloseToggle(e);
    });


    $(subscribeOptions.formNotification).find("div").hide();

    if ($(subscribeOptions.form).length > 0) {
        $(subscribeOptions.form).on("submit", function (e) {
            e.preventDefault();

            if ($(subscribeOptions.form).valid()) {
                subscribeHandler.initSubscribe(e);
            }
        });
    }
});